import { render, staticRenderFns } from "./ProductStatusChanger.vue?vue&type=template&id=04b4aebe&scoped=true&"
import script from "./ProductStatusChanger.vue?vue&type=script&lang=js&"
export * from "./ProductStatusChanger.vue?vue&type=script&lang=js&"
import style0 from "./ProductStatusChanger.vue?vue&type=style&index=0&id=04b4aebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4aebe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VContainer,VFlex,VLayout,VSelect,VTextField})
